import {Box, Grid, Typography} from "@mui/material";
import {Fragment} from "react";
import {WordPressMultiConversationChatBotOutputChat} from "./WordPressMultiConversationChatBotOutputChat";

export const WordPressMultiConversationChatBotOutput = ({
                                                            lng,
                                                            status,
                                                            service,
                                                            chatHistory,
                                                            cbHandleConfirm,
                                                            cbHandleMovingService,
                                                            packageRate,
                                                            packageLoading,
                                                            packageError,
                                                            isAbleGetPackageRate,
                                                            movingFrom,
                                                            movingTo,
                                                            emailAddress,
                                                            phoneNumber,
                                                            APIRate
                                                        }) => {

    return (
        <Box>
            <Grid container spacing={2}>
                {

                    chatHistory?.length === 0 ?
                        <Grid size={{xs: 12}}>
                            <Typography sx={{fontSize: '18px', fontWeight: '600', textAlign: 'center'}}>
                                {
                                    lng === 'cn' ? '欢迎！我们是您值得信赖的物流合作伙伴。请从以下选项中选择您需要的服务，让我们开始合作。' :
                                        'Welcome! We are your trusted logistics partner. To get started, please select the service you require from the options below.'
                                }
                            </Typography>
                        </Grid>
                        :
                        chatHistory?.map((chat, index) => (
                            <Grid size={{xs: 12}} key={index}>
                                <WordPressMultiConversationChatBotOutputChat lng={lng}
                                                                             chat={chat}
                                                                             status={status}
                                                                             service={service}
                                                                             cbHandleConfirm={cbHandleConfirm}
                                                                             cbHandleMovingService={cbHandleMovingService}
                                                                             index={index + 1}
                                                                             chatLength={chatHistory?.length}
                                                                             packageRate={packageRate}
                                                                             packageLoading={packageLoading}
                                                                             packageError={packageError}
                                                                             isAbleGetPackageRate={isAbleGetPackageRate}
                                                                             movingFrom={movingFrom}
                                                                             movingTo={movingTo}
                                                                             emailAddress={emailAddress}
                                                                             phoneNumber={phoneNumber}
                                                                             APIRate={APIRate}/>
                            </Grid>
                        ))
                }
            </Grid>
        </Box>
    )

}